import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
interface LocationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  location?: any;
}
export function LocationModal({
  isOpen,
  onClose,
  onSave,
  location
}: LocationModalProps) {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    city: '',
    type: 'studio',
    capacity: 15,
    is_active: true
  });
  useEffect(() => {
    if (isOpen) {
      setFormData({
        name: location?.name || '',
        address: location?.address || '',
        city: location?.city || '',
        type: location?.type || 'studio',
        capacity: location?.capacity || 15,
        is_active: location?.is_active ?? true
      });
    }
  }, [isOpen, location]);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-earth/50 backdrop-blur-sm" data-id="element-562">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.95
    }} className="bg-white rounded-3xl shadow-xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]" data-id="element-563">
        <div className="p-6 border-b border-mist flex justify-between items-center bg-sand/30" data-id="element-564">
          <h2 className="font-display text-2xl font-bold text-earth" data-id="element-565">
            {location ? 'Editar Ubicación' : 'Nueva Ubicación'}
          </h2>
          <button onClick={onClose} className="text-stone hover:text-earth p-2 rounded-full hover:bg-white transition-colors" data-id="element-566">
            <X size={20} data-id="element-567" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1" data-id="element-568">
          <form id="location-form" onSubmit={handleSubmit} className="space-y-5" data-id="element-569">
            <div data-id="element-570">
              <label className="block text-sm font-semibold text-earth mb-2" data-id="element-571">
                Nombre *
              </label>
              <input type="text" required value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-572" />
            </div>

            <div data-id="element-573">
              <label className="block text-sm font-semibold text-earth mb-2" data-id="element-574">
                Dirección *
              </label>
              <input type="text" required value={formData.address} onChange={e => setFormData({
              ...formData,
              address: e.target.value
            })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-575" />
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-576">
              <div data-id="element-577">
                <label className="block text-sm font-semibold text-earth mb-2" data-id="element-578">
                  Ciudad
                </label>
                <input type="text" value={formData.city} onChange={e => setFormData({
                ...formData,
                city: e.target.value
              })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-579" />
              </div>
              <div data-id="element-580">
                <label className="block text-sm font-semibold text-earth mb-2" data-id="element-581">
                  Capacidad
                </label>
                <input type="number" min="1" required value={formData.capacity} onChange={e => setFormData({
                ...formData,
                capacity: parseInt(e.target.value)
              })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-582" />
              </div>
            </div>

            <div data-id="element-583">
              <label className="block text-sm font-semibold text-earth mb-2" data-id="element-584">
                Tipo
              </label>
              <select value={formData.type} onChange={e => setFormData({
              ...formData,
              type: e.target.value
            })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10 bg-white" data-id="element-585">
                <option value="studio" data-id="element-586">Estudio</option>
                <option value="park" data-id="element-587">Parque</option>
                <option value="outdoor" data-id="element-588">Al aire libre</option>
                <option value="online" data-id="element-589">Online</option>
              </select>
            </div>

            <div className="flex items-center gap-3 pt-2" data-id="element-590">
              <input type="checkbox" id="is_active" checked={formData.is_active} onChange={e => setFormData({
              ...formData,
              is_active: e.target.checked
            })} className="w-5 h-5 text-sage rounded border-mist focus:ring-sage" data-id="element-591" />
              <label htmlFor="is_active" className="text-sm font-semibold text-earth" data-id="element-592">
                Ubicación activa
              </label>
            </div>
          </form>
        </div>

        <div className="p-6 border-t border-mist bg-sand/10 flex gap-3 justify-end" data-id="element-593">
          <button type="button" onClick={onClose} className="px-6 py-2.5 rounded-xl text-sm font-semibold text-stone hover:bg-mist/30 transition-colors" data-id="element-594">
            Cancelar
          </button>
          <button form="location-form" type="submit" className="px-6 py-2.5 rounded-xl text-sm font-semibold bg-sage text-white hover:bg-sage/90 transition-colors shadow-sm" data-id="element-595">
            Guardar
          </button>
        </div>
      </motion.div>
    </div>;
}